import React from "react";
import type { SpecsModel } from "../../specsModel/SpecsModel";
import { useSpecsModel, useSpecsModelSelector } from "../../SpecsModelContext";
import { SpecsImageUrlField } from "../../SpecsEditorFields/index";
import { useSpecsEditorContextValue } from "../../useSpecsEditor";
import {
  DEFAULT_SPECS_IMAGE_UPLOAD_VALIDATION,
  type SpecsImageUploadContext,
} from "../../specsImageUpload";

type SpecsModelImageUrlFieldProps = Omit<
  React.ComponentProps<typeof SpecsImageUrlField>,
  "value" | "onChange"
> & {
  uploadContext?: SpecsImageUploadContext;
  selector: (model: SpecsModel) => string;
  setValue: (
    model: SpecsModel,
    nextValue: string,
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
};

export default function SpecsModelImageUrlField({
  selector,
  setValue,
  ...props
}: SpecsModelImageUrlFieldProps) {
  const model = useSpecsModel();
  const value = useSpecsModelSelector(selector);
  const {
    editor: {
      identity: { productName },
    },
  } = useSpecsEditorContextValue();

  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setValue(model, event.target.value, event);
    },
    [model, setValue]
  );

  return (
    <SpecsImageUrlField
      {...props}
      value={value}
      onChange={handleChange}
      uploadValidation={
        props.uploadValidation ?? DEFAULT_SPECS_IMAGE_UPLOAD_VALIDATION
      }
      uploadContext={{
        specType: "product",
        specName: productName || undefined,
        fieldPath: props.uploadContext?.fieldPath,
      }}
    />
  );
}
